import { Dropdown } from "semantic-ui-react";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import agreementTypes from "astrid-firestore/src/api/agreements/constants/agreementTypes";

import useHasRight from "../../../../authorization/hooks/useHasRight";

import { getAgreementRenewAdminURL } from "../../../utils/agreementsHelper";

export default function RenewAgreementDropdownItem({ agreement }) {
	const { t } = useTranslation();
	const hasRight = useHasRight();

	if (!hasRight("agreements.view") || agreement.type !== agreementTypes.FRAMEWORK) {
		return null;
	}

	return (
		<Dropdown.Item as={agreement ? Link : null} to={getAgreementRenewAdminURL(agreement)} disabled={!agreement}>
			{t("renew", "Renew")}
		</Dropdown.Item>
	);
}
